module.exports = __webpack_public_path__ + "static/Website_05-936527d1a9a3453b3d256b92480a0bb2.mp4";